// SubTaskList.js
import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box,Button, MenuItem, Select, Tooltip, Menu, IconButton,Checkbox,FormControl, ListSubheader,} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CiViewList } from "react-icons/ci";
import { MdViewQuilt } from "react-icons/md";
import { Offcanvas } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { IoIosArrowBack } from "react-icons/io";
import SearchBar from "../../SearchBar";
import { CiFilter } from "react-icons/ci";
import { BsThreeDots } from "react-icons/bs";
import { PiBagFill } from "react-icons/pi";
import { deleteCommentEntities,newFilterEntities,} from "../../../apis/apiService";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import { CustomNoRowsOverlay } from "../../common/OverlayGrid";
import { CommonAddTaskTab } from "../../common/Task/CommonAddTaskTab";
import { hasTaskPermission } from "../../../utils/Permissions";
import CommonDeleteDialog from "../../common/CommonDelete";
import Movetask from "../../common/Task/Movetask";
import dayjs from "dayjs";
import useTaskTimer from "../../../assets/hooks/UseTaskTimer";
import TimerPopup from "../../common/timer/TimerPopup";
import { TaskFilterComponent } from "./TaskTab";
import { SubtaskBoardFilter } from "./SubtaskBoardfilter";
import { FilterSummaryBox } from "../../common/FilterSummaryBox";
import CommonTaskIssueNameChamge from "../../common/CommonTaskIssueNameChamge";
import SubtaskBoard from "./SubtaskBoard";
import { useTheme } from "../../../ThemeContext";
import { usePersistentFilter } from "../../../assets/hooks/usePersistentFilter";
import { extractLetters, extractTextFromHTML } from "../../../utils/textUtils";
import { openInNewTab } from "../../../utils/openInNewTab";


const transformTaskRow = (task, tasks_list_name) => {
  let ownerDisplay = "Unassigned";
  if (Array.isArray(task.owners) && task.owners.length > 0) {
    ownerDisplay =
      task.owners.length > 1
        ? `${task.owners[0].name} (+${task.owners.length - 1})`
        : task.owners[0].name;
  }
  return {
    ...task,
    id: task.id || task.task_id,
    name: task.title,
    title: task.title,
    owner: ownerDisplay,
    owners: task.owners,
    startDate: task.start_date
      ? dayjs(task.start_date).format("DD-MM-YYYY")
      : null,
    dueDate: task.end_date
      ? dayjs(task.end_date).format("DD-MM-YYYY")
      : null,
    duration: task.estimated_hours
      ? `${task.estimated_hours} hrs`
      : "N/A",
    current_status_name: task.current_status_name || "Open",
    priority: task.priority_name,
    priority_name: task.priority_name,
    added_by_name: task.added_by_name,
    completed_percentage: task.completed_percentage,
    updated_name: task.updated_name,
    task_list_name: tasks_list_name || task.task_list_name
  };
};

function SubTaskList() {
  const { isDarkMode } = useTheme();
  const { reset } = useForm();
  const { id } = useParams();
  const numericId = id.match(/\d+/)?.[0];
  const project_id = localStorage.getItem("project_id");
  const [task, setTask] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [projectDatas, setprojectDatas] = useState([]);
  const [Subtasklist, setSubtasklist] = useState([]);
  const [boardSubtasklist, setBoardSubtasklist] = useState([]);
  // //console.log()("Subtasklistt", Subtasklist);
  const [checkedTasks, setCheckedTasks] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const [headanchorEl, setheadAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // //console.log()("login_user in task:", login_user);
  const projectName = useSelector((state) => state.selectOptions?.projectName) || "";
  const { role: login_user_role, id: login_user_id } = login_user;
  // //console.log()("login_user role in task:", login_user_role);
  const [pagination_model, setPagination_model] = useState({
    page: 0,
    pageSize: 10,
  });
  const [clearFilter, setClearFilter] = useState(false);
  // const [viewMode, setViewMode] = useState("list");
  const [viewMode, setViewMode] = useState(() => {
    return (
      sessionStorage.getItem(`subtask_view_mode_${numericId}`) ||
      location.state?.viewMode ||
      "list"
    );
  });
  const [filter, setFilter] = usePersistentFilter(
    "subtaskPersistentFilter",
    login_user_role === "CLIENT" || login_user_role === "ADMIN" ? 1 : 6
  );

  const filterOptions = {
    predefined: [
      { label: "All Tasks", value: 1 },
      { label: "All Open", value: 2 },
      { label: "All closed", value: 3 },
      { label: "All Overdue & Open", value: 4 },
      { label: "Unassigned Tasks", value: 5 },
    ],

    myViews: [
      { label: "My Open", value: 6 },
      { label: "My Closed", value: 7 },
      { label: "Today's Tasks", value: 8 },
      { label: "Tasks I Follow", value: 9 },
      { label: "Tasks Created By Me", value: 10 },
    ],
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  useEffect(() => {
    if (numericId) {
      sessionStorage.setItem(`subtask_view_mode_${numericId}`, viewMode);
    }
  }, [viewMode, numericId]);

  // const {
  //   timers,
  //   activeTimerId,
  //   currentRow,
  //   isPaused,
  //   startTimer,
  //   pauseTimer,
  //   resumeTimer,
  //   stopTimer,
  //   cancelTimer,
  // } = 
  useTaskTimer();
  const [showTimerPopup, setShowTimerPopup] = useState(false);
  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value) {
      await fetchSearchedTask(value);
    } else {
      await fetchSubtasklist();
      // setProjects([]); // Clear projects if search term is empty
    }
  };
  const handleCheckboxChange = (event, row) => {
    event.stopPropagation(); // Prevents parent click handlers

    setCheckedTasks((prev) => ({
      ...prev,
      [row.id]: event.target.checked,
    }));
  };

  const handleShowFilter = () => {
    setShowFilter(true);
    sessionStorage.setItem("isTaskFilterApplied", false);
  };
  const handleShowProject = () => setShowProject(true); // Open filter

  // console.log("project_id_params :", selectedSubtask);
  const handleActionClick = (event, subtask) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    // console.log("project_id_params :", subtask);

    setSelectedSubtask(subtask);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleView = () => {
    if (!selectedSubtask?.id) {
      toast.error(" No subtask ID found!");
      return;
    }
    // //console.log()(`Navigating to task ID: ${selectedSubtask.id}`);
    // const newPath = location.pathname.replace(
    //   /\/subTaskList\/[^/]+$/, // Matches `/subTaskList/T31` or similar
    //   `/taskdetail/${selectedSubtask.id}`
    // );

    const path = `/projects/projectDetail/${selectedSubtask.project_id}/taskdetail/${selectedSubtask.id}`;
    // navigate(path);
    navigate(path, { state: { viewMode, from: location.pathname } });
    handleClose();
  };

  const handleViewDitailstab = () => {
    // //console.log()(`View task on new tab ID: ${selectedSubtask?.id}`);
    const newPath = `/projects/projectDetail/${selectedSubtask.project_id}/taskdetail/${selectedSubtask.id}`;
    // const path = `/projects/projectDetail/${params.row.project_id}/taskdetail/${params.row.id}`;
    openInNewTab(newPath);
    handleClose();
  };

  const handleCopylink = () => {
    // //console.log()(`Copy task ID: ${selectedSubtask?.id}`);
    handleClose();
  };
  const canEditTask = hasTaskPermission(
    selectedSubtask,
    login_user_id,
    login_user_role
  );

  // if (!task) return <Typography>Loading...</Typography>;
  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        const isChecked = !!checkedTasks[params.row.id];

        return (
          <Box display="flex" alignItems="center">
            {/* If not checked, show checkbox first, otherwise show menu first */}
            {!isChecked && (
              <Checkbox
                checked={isChecked}
                onChange={(e) => handleCheckboxChange(e, params.row)}
                onClick={(e) => e.stopPropagation()} // Prevents row click navigation
              />
            )}

            {isChecked && (
              <>
                <Checkbox
                  checked={isChecked}
                  onChange={(e) => handleCheckboxChange(e, params.row)}
                  onClick={(e) => e.stopPropagation()} // Prevents row click navigation
                />
                <IconButton onClick={(e) => handleActionClick(e, params.row)}>
                  <MoreHorizIcon />
                </IconButton>
              </>
            )}

            {/* Menu */}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl) && selectedSubtask?.id === params.row.id}
              onClose={handleClose}
            >
              <MenuItem onClick={handleView}>
                <CiViewList className="me-2" color="blue" />
                View Details
              </MenuItem>
              <MenuItem onClick={handleViewDitailstab}>
                <CiViewList className="me-2" color="blue" />
                View in New Tab
              </MenuItem>
              {/* <MenuItem onClick={handleCopylink}>Copy Link</MenuItem> */}
              {/* <MenuItem onClick={handleDeleteSubtask}>
                <DeleteForever color="error" className="me-2" />
                Delete task
              </MenuItem> */}
              {canEditTask && (
                <div>
                  <CommonDeleteDialog
                    name="Task"
                    refetchList={fetchSubtasklist}
                    handleListClose={handleClose}
                    url="task/delete"
                    id={selectedSubtask?.id}
                    statusName={selectedSubtask?.title}
                    logHours={selectedSubtask?.log_hours}
                  // statusName={rows.find((task)=>task.task_id === selectedTask)?}
                  />
                  <Movetask
                    handleMenuClose={handleClose}
                    login_user_id={login_user_id}
                    selectedTask={selectedSubtask}
                    path="task/moveTask"
                    project_id={project_id}
                    refetch_list={fetchSubtasklist}
                  />
                  <CommonTaskIssueNameChamge
                    name="Task"
                    path="task/update"
                    selectedTask={selectedSubtask}
                    setMenuAnchorEl={setAnchorEl}
                    refetch_list={fetchSubtasklist}
                  />
                </div>
              )}
            </Menu>
          </Box>
        );
      },
      sortable: false,
    },
    { field: "id", headerName: "ID", width: 100 },
    { field: "name", headerName: "Task Name", width: 200 },
    {
      field: "owner",
      headerName: "Owner",
      width: 150,
      renderCell: (params) => {
        const owners = params.row.owners || [];
        const displayValue = params.value;

        const tooltipTitle = owners.length > 0 ? (
          <Box>
            {owners.map((o, index) => (
              <div key={index}>{o.name}</div>
            ))}
          </Box>
        ) : "Unassigned";

        return (
          <Tooltip title={tooltipTitle} arrow>
            <Box sx={{ cursor: "pointer" }}>{displayValue}</Box>
          </Tooltip>
        );
      },
    },
    // {
    //   field: "timer",
    //   headerName: "Timer",
    //   with: 150,
    //   renderCell: (params) => {
    //     const value = params.value;
    //     return (
    //       <Box
    //         onClick={(e) => {
    //           e.stopPropagation();
    //           startTimer(params.row);
    //           setShowTimerPopup(true);
    //         }}
    //       >
    //         <CiTimer />
    //       </Box>
    //     );
    //   },
    // },
    // Previous location of Status column was here (commented out)
    {
      field: "startDate",
      headerName: "Start Date",
      width: 150,
      renderCell: (params) => {
        return (
          <Box>
            {params.value ? dayjs(params.value).format("DD-MM-YYYY") : ""}
          </Box>
        );
      },
    },
    {
      field: "dueDate",
      headerName: "Due Date",
      width: 150,
      renderCell: (params) => {
        return (
          <Box>
            {params.value ? dayjs(params.value).format("DD-MM-YYYY") : ""}
          </Box>
        );
      },
    },
    { field: "duration", headerName: "Duration", width: 150 },
    {
      field: "current_status_name",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        const status_colour = params.row.status_colour;
        const value = params.value;
        return <Box sx={{ color: status_colour || "black" }}>{value}</Box>;
      },
    },
    {
      field: "priority",
      headerName: "Priority",
      width: 120,
      renderCell: (params) => {
        const status = params.value || "N/A";
        const color = params.row.priority_colour || "var(--text-color)";
        return (
          <Box
            sx={{
              color: color,
              textTransform: "capitalize",
            }}
          >
            {status}
          </Box>
        );
      },
    },
    {
      field: "description",
      headerName: "Description",
      width: 200,
      renderCell: (params) => {
        const text = extractTextFromHTML(params.value);
        if (!text) return "";
        return (
          <Tooltip title={text} arrow>
            <Box
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                cursor: "pointer",
              }}
            >
              {text}
            </Box>
          </Tooltip>
        );
      },
    },
    {
      field: "completed_percentage",
      headerName: "Completed %",
      width: 150,
      renderCell: (params) => {
        return (
          <Box>
            {params.value !== undefined && params.value !== null ? `${params.value}%` : "0%"}
          </Box>
        );
      },
    },
    {
      field: "billing_type",
      headerName: "Billable Type",
      width: 150,
      renderCell: (params) => {
        return (
          <Box>
            {params.value || "N/A"}
          </Box>
        );
      },
    },
    {
      field: "added_by_name",
      headerName: "Created By",
      width: 180,
      renderCell: (params) => {
        return <Box>{params.value || "N/A"}</Box>;
      },
    },
    {
      field: "added_at",
      headerName: "Created At",
      width: 180,
      renderCell: (params) => {
        if (!params.value) return null;
        const d = dayjs(params.value);
        return (
          <Box>
            {d.isValid() ? d.format("DD-MM-YYYY hh:mm A") : params.value}
          </Box>
        );
      },
    },
    {
      field: "updated_name",
      headerName: "Updated By",
      width: 180,
      renderCell: (params) => {
        return <Box>{params.value || "----------"}</Box>;
      },
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 180,
      renderCell: (params) => {
        if (!params.value) return null;
        const d = dayjs(params.value);
        return (
          <Box>
            {d.isValid() ? d.format("DD-MM-YYYY hh:mm A") : params.value}
          </Box>
        );
      },
    },
  ];

  const handleClick = (event) => {
    setheadAnchorEl(event.currentTarget);
  };
  const HeadhandleClose = () => {
    setheadAnchorEl(null); // Ensure this sets the anchor element to null to close the menu
  };
  const handleBackClick = () => {
    navigate(-1); // Navigates to the previous page
  };

  const fetchSubtasklist = async () => {
    setLoading(true);
    try {
      const response = await newFilterEntities("task/show", numericId, {
        view_type_id: filter,
      });
      // setSubtasklist(response.data); // Set the subtasks data in state

      // Changed to ensure task_id is mapped to id for Kanban and DataGrid consistency
      const mappedData = (response.data || []).map(task =>
        transformTaskRow(task, response.tasks_list_name)
      );
      setSubtasklist(mappedData);
      setBoardSubtasklist(mappedData);

      // setprojectDatas(response);
      const { task_open_count, task_close_count, tasks_list_name } = response;
      setprojectDatas({
        task_open_count,
        task_close_count,
        tasks_list_name
      });
      // setClearFilter(false); // Removed to prevent reset when switching tabs
    } 
    catch (err) {
      // Show error in toast
      toast.error(err.message || "Failed to fetch subtasks");
    } 
    finally {
      setLoading(false);
    }
  };
  
  const handleFilterApply = (PreviousData) => {
    setSubtasklist(
      PreviousData.map((data) => transformTaskRow(data))
    );
    setShowFilter(false);
    setClearFilter(true);
  };

  useEffect(() => {
    fetchSubtasklist();
  }, [numericId, filter]);

  // search Api call
  const fetchSearchedTask = async (searchQuery) => {
    try {
      const response = await newFilterEntities("task/show", numericId, {
        // search: searchQuery,
        search: searchQuery.trim(),
      });

      if (response.status) {
        const mappedData = response.data.map((item) => transformTaskRow(item));
        setSubtasklist(mappedData);
        setBoardSubtasklist(mappedData);
      } else {
        setSubtasklist([]);
        setBoardSubtasklist([]);
      }
    } 
    catch (error) {
      console.error("Failed to fetch tasks:", error);
      setSubtasklist([]);
      setBoardSubtasklist([]);
    }
  };

  const deleteTaskList = async () => {
    try {
      const response = await deleteCommentEntities( "tasklist/delete", numericId );
      // //console.log()("task_delete_response: ", response);
      toast.success(response.message);
      // navigate("/tasks")
      fetchSubtasklist();
    } 
    catch (err) {
      console.error("Failed to delete task:", err);
      toast.error(err.message);
    } 
    finally {
      handleClose();
    }
  };

  const handleRowClick = (params) => {
    // console.log("project_id_params box :", params);

    // navigate(
    //   `/projects/projectDetail/${params.row.project_id}/taskdetail/${params.row.task_id}`
    // );

    navigate(
      `/projects/projectDetail/${params.row.project_id}/taskdetail/${params.row.task_id}`,
      { state: { viewMode, from: location.pathname } }
    );
  };

  // const

  // const { tasks_list_name, task_open_count, task_close_count } = projectDatas;
    const { tasks_list_name } = projectDatas;
  // const { tasks_list_name, task_open_count, task_close_count } = projectDatas;
  const task_open_count = Subtasklist.filter(t => (t.current_status_name || t.status_name || "").toUpperCase() === "OPEN").length;
  const task_close_count = Subtasklist.filter(t => (t.current_status_name || t.status_name || "").toUpperCase().includes("CLOSED")).length;

  // console.log("tasks_list_name", selectedSubtask);
  const handleClearFilter = () => {
    fetchSubtasklist();
    sessionStorage.setItem("isTaskFilterApplied", false);
    sessionStorage.removeItem("task_filter_data");
    setClearFilter(false);
  };

  const handleClearBoardFilter = () => {
    fetchSubtasklist();
    sessionStorage.setItem("isBoardFilterApplied", false);
    sessionStorage.removeItem("board_filter_data");
    setClearFilter(false);
  };

  // //console.log()(" project_datas :", projectDatas);
  useEffect(() => {
    const isTaskApplied = sessionStorage.getItem("isTaskFilterApplied") === "true";
    const isBoardApplied = sessionStorage.getItem("isBoardFilterApplied") === "true";

    if (viewMode === "list") {
      setClearFilter(isTaskApplied);
    } else {
      setClearFilter(isBoardApplied);
    }
  }, [viewMode, Subtasklist, boardSubtasklist]);

  return (
    <>
      <Offcanvas
        show={showProject}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          {/* <AddSubTaskComponent
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
            fetchSubtasklist={fetchSubtasklist}
          /> */}
          <CommonAddTaskTab
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
            // refetchList={fetchSubtasklist}
            refetchList={() => {
              fetchSubtasklist();
              setSearchTerm(""); // Reset search bar after adding a task
            }}
            path_1="task"
            path_2="add"
            isSubtaskList={true}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <TimerPopup
        showTimerPopup={showTimerPopup}
        setShowTimerPopup={setShowTimerPopup}
      />
      {/* Add filter */}
      <Offcanvas show={showFilter} placement="end" style={{ width: "50%" }}>
        <Offcanvas.Body className="p-0">
          {/* {viewMode === "board" ? ( */}
          {showFilter && (viewMode === "board" ? (
            <SubtaskBoardFilter
              project_id={project_id}
              filter_path="/task/show"
              isMilestoneTask={false}
              isSubtask={true}
              task_list_id={numericId}
              filterid={filter}
              onApply={(data) => {
                setBoardSubtasklist(
                  data.map((item) => transformTaskRow(item))
                );
                setShowFilter(false);
                setClearFilter(true);
              }}
              onClear={handleClearBoardFilter}
              onCancel={() => setShowFilter(false)}
            />
          ) : (
            /* Previous TaskFilterComponent (commented for board, but kept for list view) */
            <TaskFilterComponent
              project_id={project_id}
              filter_path="/task/show"
              isMilestoneTask={false}
              isSubtask={true}
              task_list_id={numericId}
              filterid={filter}
              onApply={handleFilterApply}
              // onClear={() => reset()} // Resets to initial values
              onClear={() => {
                fetchSubtasklist();
                sessionStorage.setItem("isTaskFilterApplied", false);
                sessionStorage.removeItem("task_filter_data");
              }}
              onCancel={() => setShowFilter(false)}
            />
          ))}
        </Offcanvas.Body>
      </Offcanvas>

      <div className="d-flex justify-content-between align-items-center bg-white mb-3  p-3 border-bottom rounded-bottom">
        <div className="d-flex align-items-center gap-3">
          <button className="R_btn me-2" onClick={handleBackClick}>
            <IoIosArrowBack className="text-rgba-gray" size={17} />
          </button>
          
          <label className="text-rgba-gray m-0 d-flex align-items-center gap-1">
            <PiBagFill className="text-rgba-gray" />
            Project Name: <span className="fw-semibold text-dark ms-1">{extractLetters(projectName)}</span>
          </label>

          <span className="text-rgba-gray border-start ps-3 py-1">
            Task List Name: <span className="fw-semibold text-dark ms-1">{extractLetters(tasks_list_name)}</span>
          </span>
        </div>

        <div className="d-flex align-items-center">
          <div>
            <span>{task_open_count}</span>
            <lable className="text-rgba-gray"> Open</lable>
          </div>

          <div className="ps-3">
            <span>{task_close_count}</span>
            <lable className="text-rgba-gray"> Closed</lable>
          </div>

          {Subtasklist.length === 0 && (
            <div className="ps-3">
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                <BsThreeDots className="text-rgba-gray" />
              </IconButton>

              <Menu
                id="long-menu"
                anchorEl={headanchorEl}
                open={Boolean(headanchorEl)}
                onClose={HeadhandleClose}
                PaperProps={{
                  style: {
                    maxHeight: 48 * 4.5,
                    width: "20ch",
                  },
                }}
              >
                <MenuItem onClick={deleteTaskList}>Delete</MenuItem>
              </Menu>
            </div>
          )}
        </div>
      </div>

      <div className="bg-white">
        <Box
          className="d-flex justify-content-between align-items-center gap-3"
          sx={{
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "12px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
          }}
        >
          <div className="d-flex gap-3 align-items-center">
            <FormControl size="small" sx={{ width: "auto" }}>
              <Select
                value={filter}
                onChange={handleFilterChange}
                displayEmpty
                size="small"
                sx={{
                  borderRadius: "5px",
                  width: "auto",
                  minWidth: "100px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: isDarkMode ? "#444" : "#e0e0e0",
                  },
                }}
              >
                <ListSubheader className="ps-3 text-rgba-gray">
                  Predefined Views
                </ListSubheader>
                {filterOptions.predefined.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}

                <ListSubheader className="ps-3 text-rgba-gray">
                  My Views
                </ListSubheader>
                {filterOptions.myViews.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <div className="d-flex align-items-center" style={{ gap: "6px", alignSelf: "center" }}>
              <Tooltip title="Table View">
                <IconButton
                  onClick={() => {
                    setViewMode("list");
                    fetchSubtasklist();
                  }}
                  sx={{
                    backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                    color: viewMode === "list" ? "rgba(18, 183, 159, 1)" : "#626161",
                    border: viewMode === "list" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                    borderRadius: "4px",
                    height: "34px",
                    width: "75px",
                    gap: "4px",
                    fontSize: "13px",
                    fontWeight: 500,
                    marginRight: "10px",
                    "&:hover": {
                      backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <CiViewList size={18} />
                  Table
                </IconButton>
              </Tooltip>

              <Tooltip title="Board View">
                <IconButton
                  onClick={() => {
                    setViewMode("board");
                    fetchSubtasklist();
                  }}
                  sx={{
                    backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                    color: viewMode === "board" ? "rgba(18, 183, 159, 1)" : "#626161",
                    border: viewMode === "board" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                    borderRadius: "4px",
                    height: "34px",
                    width: "75px",
                    gap: "4px",
                    fontSize: "13px",
                    fontWeight: 500,
                    "&:hover": {
                      backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <MdViewQuilt size={18} />
                  Board
                </IconButton>
              </Tooltip>
            </div>
          </div>

          <div className="d-flex align-items-center">
            <SearchBar
              placeholder="Search tasks"
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
            />
            {clearFilter && (
              <button
                type="button"
                // onClick={handleClearFilter}
                onClick={viewMode === "board" ? handleClearBoardFilter : handleClearFilter}
                className=" addmore_btn"
                disabled={loading}
              >
                Clear filter
              </button>
            )}

            {/* {login_user_role != "CLIENT" && ( */}
            <Button
              className="AddButton rounded me-3 ms-2"
              onClick={handleShowProject}
            >
              Add Tasks
            </Button>
            {/* )} */}

            <Tooltip title="Filter">
              <IconButton
                onClick={handleShowFilter}
                sx={{
                  backgroundColor: isDarkMode
                    ? "rgba(67, 105, 255, 0.08)"
                    : "#F1F5FF",
                  borderRadius: "50%",
                  width: "39px",
                  height: "39px",
                  "&:hover": {
                    backgroundColor: "var(--icon-hover-bg)",
                  },
                  marginRight: "2px",
                }}
              >
                <CiFilter className="text-rgbr-blue pro-icon-s" />
              </IconButton>
            </Tooltip>
          </div>
        </Box>
        
        <div style={{ width: "100%" }}>
          {loading ? (
            <Loader />
          ) : viewMode === "board" ? (
            <SubtaskBoard numericId={numericId} allTasks={boardSubtasklist} onRefresh={fetchSubtasklist} loading={loading} />
          ) : (
            <div className="row">
              <div className="col-12 ">
                <FilterSummaryBox
                  onApply={handleFilterApply}
                  status_type="TASK"
                  task_filter_id={numericId}
                  // filter_path="/project/filter"
                  filter_path="/task/show"
                />
              </div>
              <div className="col-12">
                <Box sx={{ height: Subtasklist.length === 0 ? 300 : "100%" }}>
                  <DataGrid
                    rows={Subtasklist}
                    columns={columns}
                    pagination
                    pageSizeOptions={[10, 20, 30, 40]}
                    paginationModel={pagination_model}
                    onPaginationModelChange={setPagination_model}
                    slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                    sx={{ "& .MuiDataGrid-root": { minHeight: "300px" } }}
                    getRowId={(row) => row.id || row.task_id}
                    onRowClick={handleRowClick}
                  />
                </Box>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default SubTaskList;
